import React from 'react';
import NewAptStartTest from './NewAptStartSteps';

const Index = () => {
  return (
    <div className='w-full'>
      <NewAptStartTest />
    </div>
  );
};

export default Index;
